export const EDUCATION_CENTER_INFO = 'educationCenterInfo';
export const HOSPITAL = 'hospital';
export const DEPARTMENT = 'department';
export const LESSON_PLACE = 'lessonPlace';

const tabGroups = [EDUCATION_CENTER_INFO, HOSPITAL, DEPARTMENT, LESSON_PLACE];

export default tabGroups;
